import { compose } from 'recompose';

import SubscriberShow from './SubscriberShow';

const enhance = compose();

export default enhance(SubscriberShow);
